import { useEffect, useRef, useState } from "react";

export function useInventoryTakingFilters({ lookups, filtersState, setFilterOptions, handleFilterChange, handleApplyFilters }) {
	const seasonInitializedRef = useRef(false);
	const lastSeasonIdRef = useRef(null);
	const [pendingApply, setPendingApply] = useState(false);
	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		if (!lookups) return;

		if (lookups.users) {
			setFilterOptions(
				"user_id",
				lookups.users.map((user) => ({ value: String(user.value), label: user.label })),
				false,
			);
		}

		if (lookups.seasons) {
			setFilterOptions("season_id", lookups.seasons, false);

			if (!seasonInitializedRef.current) {
				const activeSeason = lookups.seasons.find((season) => season.active === true || season.active === 1);

				if (activeSeason) {
					handleFilterChange("season_id", activeSeason.value);
					if (activeSeason.start_date) handleFilterChange("date_from", activeSeason.start_date);
					if (activeSeason.end_date) handleFilterChange("date_to", activeSeason.end_date);
					seasonInitializedRef.current = true;
					setPendingApply(true);
					return;
				}

				seasonInitializedRef.current = true;
			}
		}

		setIsReady(true);
	}, [lookups, setFilterOptions, handleFilterChange]);

	useEffect(() => {
		if (!pendingApply || !handleApplyFilters || !filtersState) return;

		const seasonFilter = filtersState.find((filter) => filter.key === "season_id");
		const dateFromFilter = filtersState.find((filter) => filter.key === "date_from");

		if (seasonFilter?.value && dateFromFilter?.value) {
			handleApplyFilters();
			setPendingApply(false);
			setIsReady(true);
			lastSeasonIdRef.current = seasonFilter.value;
		}
	}, [pendingApply, filtersState, handleApplyFilters]);

	useEffect(() => {
		if (!lookups?.seasons || !filtersState || !seasonInitializedRef.current || pendingApply) return;

		const seasonFilter = filtersState.find((filter) => filter.key === "season_id");
		const currentSeasonId = seasonFilter?.value;

		if (!currentSeasonId || currentSeasonId === lastSeasonIdRef.current) return;
		lastSeasonIdRef.current = currentSeasonId;

		const selectedSeason = lookups.seasons.find((season) => String(season.value) === String(currentSeasonId));
		if (!selectedSeason) return;

		if (selectedSeason.start_date) handleFilterChange("date_from", selectedSeason.start_date);
		if (selectedSeason.end_date) handleFilterChange("date_to", selectedSeason.end_date);
	}, [lookups?.seasons, filtersState, handleFilterChange, pendingApply]);

	return { isReady };
}
